<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="card-title">Lavorazioni</h4>
                </div>
                <div class="col-md-6">
                  <fg-input type="text"
                          label=""
                          placeholder="Cerca..."
                          v-model="pattern">
                  </fg-input>
                </div>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12 table-responsive">
                <l-table class="table-hover table-striped"
                         :columns="lavorazioniColumns"
                         :data="lavorazioni"
                         :url="url"
                         :pattern="pattern"
                         :getRowClass="lavorazioniRowClass"
                         @onClick="onClick">
                </l-table>
              </div>
              <div class="col-md-12 text-right">
                <button type="button" class="btn btn-info btn-fill" @click.prevent="newLavorazione">
                  Nuova Lavorazione
                </button>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/UIComponents/Table.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  
  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        url: process.env.API_URL + 'lavorazione?withTrashed=true',
        lavorazioniColumns: [
          {
            key: 'lavorazione',
            text: 'Lavorazione'
          }
        ],
        lavorazioniRowClass: function (data) {
          return data.deleted_at ? 'text-danger' : ''
        },
        lavorazioni: [],
        pattern: this.$route.params.pattern
      }
    },
    methods: {
      onClick: function (data) {
        this.$root.$router.push('/dashboard/lavorazione/' + data.id)
      },
      newLavorazione: function () {
        this.$root.$router.push('/dashboard/lavorazione-new')
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/LavorazioneList.vue